<template lang="pug">
    form.fields(action="javascript://")
        .fields__element(v-if="user.pointsAccesses.length > 1")
            label.fields__label {{ $i18n.t('templates.template_form_coursesTypes') }}
            cs-multiselect.fields__input(
                v-model="selectedCourseType"
                :options="coursesTypes"
                :allow-empty="false"
                :multiple="false"
                track-by="mode"
                label="label"
                v-validate="'required'"
                data-vv-value-path="innerValue",
                data-vv-name="coursesTypes",
                :placeholder="$i18n.t('templates.template_form_selectCoursesTypes')"
                @select="handleCourseTypeSelect($event.mode)"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_course') }}
            cs-multiselect.fields__input(
                :options="courses",
                v-model="form.course",
                :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                @open="getCourses",
                :multiple="false",
                :allowEmpty="true",
                :loading="loadingCourses",
                label="name",
                trackBy="id"
            )
        .fields__element
            label.fields__label {{ $i18n.t('fields.fields_name') }}
            cs-search-input(
                v-model="form.name"
                @search="sendForm"
                @keyup.native.enter="sendForm"
            )
        .fields__element(v-if="user.pointsAccesses.length > 1")
        .fields__element.fields__element--fluid
            cs-button(
                color="blue",
                pattern="primary-outline",
                html-tag="a"
                href="javascript://"
                @click="resetResults",
                narrow
            )
                | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    import { mapState } from 'vuex';
    import CourseApi from '../../../api/course';
    import i18n from '../../../build/services/vuei18n';
    import searchParamsStore from '../utils/searchParamsStore';
    import { debounce } from 'lodash';

    const COURSES_TYPES = [
        {
            label: i18n.t('common.common_course_mentalArithmetic'),
            mode: 'mentalArithmetic',
        },
        {
            label: i18n.t('common.common_course_fastReading'),
            mode: 'fastReading',
        },
        {
            label: i18n.t('common.common_course_onlineSchool'),
            mode: 'onlineSchool',
        },
        {
            label: i18n.t('common.common_course_mathMagic'),
            mode: 'mathMagic',
        },
        {
            label: i18n.t('common.common_course_memoryDevelopment'),
            mode: 'memoryDevelopment',
        },
        {
            label: i18n.t('common.common_course_multiplication'),
            mode: 'multiplication',
        },
        {
            label: i18n.t('common.common_course_readingEn'),
            mode: 'readingEn',
        },
        {
            label: i18n.t('common.common_course_russianLanguage'),
            mode: 'russianLanguage',
        },
    ];
    export default {
        mixins: [searchParamsStore],
        data() {
            return {
                courses: [],
                loadingCourses: false,
                form: {
                    name: null,
                    course: null,
                    coursesType: '',
                },
                coursesTypes: COURSES_TYPES,
                selectedCourseType: COURSES_TYPES[0],
                courseTypeChanged: false,
            };
        },
        watch: {
            selectedCourseType() {
                this.updateList();
            },
            'form.course'() {
                this.updateList();
            },
            'form.name'() {
                this.updateList();
            },
            'form.courseType'() {
                this.updateList();
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        },
        methods: {
            handleCourseTypeSelect(mode) {
                this.form.coursesType = mode;
                this.courseTypeChanged = true;
            },
            getCourses() {
                if (this.courses.length && !this.courseTypeChanged) {
                    return;
                }
                this.loadingCourses = true;
                CourseApi.list({
                    all: true,
                    accessType: this.selectedCourseType.mode,
                })
                    .then(data => {
                        let courses = data.courses;
                        this.courses = courses ? Object.values(courses) : [];
                    })
                    .catch(() => {
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    })
                    .finally(() => {
                        this.loadingCourses = false;
                        this.courseTypeChanged = false;
                    });
            },
            sendForm() {
                this.$emit('search', this.form);
            },
            resetResults() {
                this.selectedCourseType = null;
                this.form.name = null;
                this.form.coursesType = null;
                this.form.course = null;
                this.$emit('search', this.form);
            },
            updateList: debounce(function() {
                this.sendForm();
            }, 1000),
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../assets/sass/fields/fields.scss';
</style>
